"use client";

import React, { useState } from "react";

import ReviewSubmissionForm from "@/components/reviews/ReviewSubmissionForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export default function WriteReviewModal() {
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex w-full max-w-md items-center justify-center gap-2 rounded-xl bg-violet-600 px-8 py-4 text-lg font-semibold text-white shadow-lg transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2"
          aria-label="Open write a review form"
        >
          Write a review
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto border-violet-200 bg-white p-6 sm:rounded-xl">
        <DialogTitle className="text-xl font-bold text-violet-950">
          Write a review
        </DialogTitle>
        <DialogDescription className="text-violet-700">
          Share your experience with Trichos. We&apos;ll receive it by email and
          publish it here after a quick check.
        </DialogDescription>
        <div className="mt-4">
          <ReviewSubmissionForm onSuccess={handleSuccess} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
